
namespace Matrix.Data {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter])
    export class SecurityRepairLogFormatter implements Serenity.ISlickFormatter {
        format(ctx: Slick.FormatterContext) {
            if (!ctx.value)
                return "";

            var color;
            if (ctx.value === "SUCCEEDED")
                color = "green";
            else if (ctx.value.includes("FAIL"))
                color = "red";
            else
                color = "amber";

            return `<span class="text-${color}"><i class="fa fa-circle"></i> ${Q.htmlEncode(ctx.value)}</span>`;
        }
    }
}